import React from "react";

const NoMatch = () => {
  return (
     <section className="p-4 text-center text-4xl">
      <p>There's nothing here !</p>
     </section>
  )
}

export default NoMatch